import React, { useEffect, useRef, useState } from 'react';
import { Spinner } from '../../../components/UI/Spinner/Spinner';
import useSingleEVStyles from './useSingleEVStyles';
import {
    Box,
    Button,
    Divider,
    Grid,
    ListItemIcon,
    Paper,
    Popover,
    Switch,
    TextField,
    Tooltip,
    Typography,
    withStyles,
} from '@material-ui/core';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import BatteryIcon from '../components/BatteryIcon';
import NearMeIcon from '@material-ui/icons/NearMe';
import { SINGLE_EV_ACTION_TYPES } from './helper';
import ToggleOffIcon from '@material-ui/icons/ToggleOff';
import ToggleOnIcon from '@material-ui/icons/ToggleOn';
import clsx from 'clsx';
import {
    VerifyKycIcon,
    PaymentSummaryIcon,
    EVVehicleRider,
    EVVehicleMap,
} from '../../../assets/svg';
import Tabbar from '../../../components/Tabbar';
import TabTitle from '../../../components/TabTitle';
import EVTaggingHistory from './EVTaggingHistory';
import RiderMapView from '../../map-view/MapDetailsV3';
import useSingleEVTable from './useSingleEVtable';
import ArrowDropDownCircleIcon from '@material-ui/icons/ArrowDropDownCircle';
import StorageIcon from '@material-ui/icons/Storage';
import {
    BarChart,
    CartesianGrid,
    Legend,
    ResponsiveContainer,
    Tooltip as RechartsTooltip,
    XAxis,
    YAxis,
    Bar,
    Rectangle,
} from 'recharts';
import {
    blockUnblockEV,
    energyControlEV,
    evBlockAPI,
    getEvCommandHistory,
    getEvOverview,
    getEvVehicleHistory,
    getEvVehiclePerformance,
} from '../../../store/actions/settingsActionCreator';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import HistoryIcon from '@material-ui/icons/History';
import { useDispatch } from 'react-redux';
import moment from 'moment';
import { showMessage, formatEvBlockResult } from '../../../utils/helper';
import { openGoogleMaps } from '../helper';
import ConfirmModal from '../../../components/Modals/ConfirmModal';
const IOSSwitch = withStyles((theme) => ({
    root: {
        width: 32,
        height: 18,
        padding: 0,
        margin: 0,
    },
    switchBase: {
        padding: 1,
        '&$checked': {
            transform: 'translateX(16px)',
            color: theme.palette.common.white,
            '& + $track': {
                backgroundColor: '#4CAF50',
                opacity: 1,
                border: 'none',
            },
        },
        '&$focusVisible $thumb': {
            color: '#4CAF50',
            border: '6px solid #fff',
        },
    },
    thumb: {
        width: 16,
        height: 16,
    },
    track: {
        borderRadius: 18 / 2,
        border: `1px solid ${theme.palette.grey[400]}`,
        backgroundColor: theme.palette.grey[50],
        opacity: 1,
        transition: theme.transitions.create(['background-color', 'border']),
    },
    checked: {},
    focusVisible: {},
}))(({ classes, ...props }: any) => {
    return (
        <Switch
            focusVisibleClassName={classes.focusVisible}
            disableRipple
            classes={{
                root: classes.root,
                switchBase: classes.switchBase,
                thumb: classes.thumb,
                track: classes.track,
                checked: classes.checked,
            }}
            {...props}
        />
    );
});
interface SingleEVProps {
    [key: string]: any;
}
const SingleEV: React.FC<SingleEVProps> = ({ ...props }) => {
    const dispatch = useDispatch();

    const dispatchGetAllEVHistory = (
            payload: any,
            onSuccess?: Function,
            onError?: Function,
        ) => dispatch(getEvVehicleHistory(payload, onSuccess, onError)),
        dispatchGetEvCommandHistory = (
            payload: any,
            onSuccess?: Function,
            onError?: Function,
        ) => dispatch(getEvCommandHistory(payload, onSuccess, onError)),
        dispatchBlockUnblockEV = (
            payload: any,
            onSuccess?: Function,
            onError?: Function,
        ) => dispatch(blockUnblockEV(payload, onSuccess, onError)),
        dispatchGetPerformance = (
            payload: any,
            onSuccess?: Function,
            onError?: Function,
        ) => dispatch(getEvVehiclePerformance(payload, onSuccess, onError)),
        dispatchEnergyControlEV = (
            payload: any,
            onSuccess?: Function,
            onError?: Function,
        ) => dispatch(energyControlEV(payload, onSuccess, onError)),
        dispatchEvBlock = (
            payload: any,
            onSuccess?: Function,
            onError?: Function,
        ) => dispatch(evBlockAPI(payload, onSuccess, onError));
    const [loading, setLoading] = useState(false);
    const [evDetails, setEVDetails] = useState<any>(null);
    const [confirmModalOpen, setConfirmModalOpen] = useState(false);
    const [confirmData, setConfirmData] = useState<any>(null);
    const [telematicConfirm, setTelematicConfirm] = useState<{ action: string; label: string; isEnergy: boolean } | null>(null);
    const [remarksInput, setRemarksInput] = useState<string>('');
    const [currentRider, setCurrentRider] = useState<any>(null);
    const [tabIndex, setTabIndex] = useState(
        props?.location?.state?.selectedTab ?? 0,
    );
    const [historyData, setHistoryData] = useState<any>({
        evHistoryLineItems: [],
    });
    const [performanceData, setPerformanceData] = useState<any>({});
    const [commandHistory, setCommandHistory] = useState<any[]>([]);
    const [commandHistoryLoading, setCommandHistoryLoading] = useState(false);
    const [overviewData, setOverviewData] = useState<any>(null);
    const [overviewLoading, setOverviewLoading] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);

    const [modalTabIndex, setModalTabIndex] = useState(-1);

    useEffect(() => {
        setEVDetails(props?.location?.state?.payload);
        if (props?.location?.state?.payload?.evId) {
            fetchEVHistoryListData({
                id: props?.location?.state?.payload?.evId,
            });
        }
    }, [props?.location?.state?.payload]);
    useEffect(() => {
        if (evDetails?.evId) {
            fetchEVHistoryListData({
                id: evDetails?.evId,
            });
            fetchEVPerformanceListData({
                evId: evDetails?.evId,
            });
            fetchCommandHistory(evDetails?.evId);
            fetchEvOverview(evDetails?.evId);
        }
    }, [evDetails?.evId]);
    const fetchEvOverview = (evId: any) => {
        setOverviewLoading(true);
        dispatch(
            getEvOverview(
                { id: evId },
                (data: any) => {
                    setOverviewLoading(false);
                    if (data?.status?.code === 200) {
                        setOverviewData(data?.response ?? null);
                    }
                },
                () => setOverviewLoading(false),
            ),
        );
    };
    const fetchCommandHistory = (evId: any) => {
        setCommandHistoryLoading(true);
        dispatchGetEvCommandHistory(
            { id: evId },
            (data: any) => {
                setCommandHistoryLoading(false);
                if (data?.status?.code === 200) {
                    setCommandHistory(data?.response?.commandHistory ?? []);
                }
            },
            () => setCommandHistoryLoading(false),
        );
    };
    useEffect(() => {
        setCurrentRider(
            historyData?.evHistoryLineItems?.filter(
                (item: any) => !item.returnedDateEpochMillis,
            )?.[0],
        );
    }, [historyData]);
    const onPressMobilize = async (row: any) => {
        if (!!row?.evId && !!row?.iotPartnerRemoteControlEnabled) {
            setLoading(true);
            dispatchEvBlock(
                {
                    evId: row?.evId,
                    action: !!row?.evTelematicInfo?.mobiliStatus
                        ? 'mobilize'
                        : 'immobilize',
                },
                (resp: any) => {
                    setLoading(false);
                    const { message, variant } = formatEvBlockResult(resp);
                    showMessage(message, variant);
                    props?.history.push('/ev-sp', {
                        payload: props?.location?.state?.payload,
                        selectedFilter: props?.location?.state?.selectedFilter,
                    });
                },
                () => {
                    setLoading(false);
                },
            );
        }
    };
    const executeTelematicAction = () => {
        if (!telematicConfirm) return;
        const confirmed = telematicConfirm;
        const remarks = remarksInput?.trim() || undefined;
        setTelematicConfirm(null);
        setRemarksInput('');
        setLoading(true);
        const payload: any = { evId: evDetails?.evId, action: confirmed.action, remarks };
        // Vehicle-level block/unblock (mobilize/immobilize) goes through the cascading
        // /org/ev/block wrapper — energy partner first, IoT fallback. Partner-specific
        // commands (IGN_ON/IGN_OFF/SEAT_OPEN/SEAT_CLOSE) keep their direct endpoints.
        const isVehicleBlock = confirmed.action === 'mobilize' || confirmed.action === 'immobilize';
        const dispatchFn = isVehicleBlock
            ? dispatchEvBlock
            : (confirmed.isEnergy ? dispatchEnergyControlEV : dispatchBlockUnblockEV);
        dispatchFn(
            payload,
            (resp: any) => {
                setLoading(false);
                if (isVehicleBlock) {
                    const { message, variant } = formatEvBlockResult(resp);
                    showMessage(message, variant);
                } else {
                    showMessage(resp?.status?.message, resp?.status?.code === 200 ? 'success' : 'error');
                }
            },
            () => { setLoading(false); },
        );
    };
    const classes: any = useSingleEVStyles();
    const handlePerformClick = (event: any) => {
        event?.stopPropagation();
        event?.preventDefault();
        setAnchorEl(event.currentTarget);
    };
    const handlePerformClose = (e: any) => {
        e?.stopPropagation();
        e?.preventDefault();
        setAnchorEl(null);
    };
    const fetchEVHistoryListData = async (payload: any) => {
        if (evDetails?.evId) {
            dispatchGetAllEVHistory(
                {
                    id: evDetails?.evId,
                    ...payload,
                },
                (data: any) => {
                    if (
                        data &&
                        data.status &&
                        data.status.code &&
                        data.status.code == 200
                    ) {
                        if (data && data.response) {
                            setHistoryData(data?.response);
                        }
                    }
                },
                (err: any) => {},
            );
        }
    };
    const fetchEVPerformanceListData = async (payload: any) => {
        dispatchGetPerformance(
            {
                evId: evDetails?.evId,
                startDate: moment()?.subtract(3, 'days')?.format('YYYY-MM-DD'),
                endDate: moment()?.format('YYYY-MM-DD'),
                ...payload,
            },
            (data: any) => {
                if (
                    data &&
                    data.status &&
                    data.status.code &&
                    data.status.code == 200
                ) {
                    if (data && data.response) {
                        setPerformanceData(data?.response);
                    }
                }
            },
            (err: any) => {},
        );
    };
    const open = Boolean(anchorEl);
    const evGoalId = open ? 'simple-popover-ev-performance' : undefined;
    const CARD_ACTION_CTA = [
        {
            text: 'Location',
            type: SINGLE_EV_ACTION_TYPES.LOCATION,
            icon: 'location',
            show:
                !!evDetails?.iotPartnerTelematicsEnabled &&
                !!evDetails?.evTelematicInfo?.latitude &&
                !!evDetails?.evTelematicInfo?.longitude,
            component: (
                <Button
                    variant="contained"
                    onClick={() => {
                        openGoogleMaps(
                            evDetails?.evTelematicInfo?.latitude,
                            evDetails?.evTelematicInfo?.longitude,
                        );
                    }}
                    disabled={false}
                    disableElevation
                    startIcon={<NearMeIcon />}
                    className={classes.locationCTA}
                >
                    Location
                </Button>
            ),
        },
        {
            text: 'Edit Info',
            type: SINGLE_EV_ACTION_TYPES.EDIT,
            icon: 'edit',
            show: false,
            component: (
                <Button
                    variant="contained"
                    color="primary"
                    onClick={() => {}}
                    disabled={false}
                    disableElevation
                >
                    Edit Info
                </Button>
            ),
        },
    ];

    const getChartLabel = (key: any) => {
        let label = '';
        switch (key) {
            case 'evKm':
                label = 'EV-KM';
                break;
            case 'orderKm':
                label = 'Order-KM';
                break;
            case 'moonLight':
                label = 'Moon Lighting %';
                break;
            default:
                break;
        }
        return label;
    };
    let currentActiveRider = historyData?.evHistoryLineItems?.filter(
        (item: any) => !item.returnedDateEpochMillis,
    );
    const data =
        !!performanceData &&
        performanceData?.evPerformance &&
        !!Object.keys(performanceData?.evPerformance)?.length
            ? Object.keys(performanceData?.evPerformance).map((perm) => {
                  const performance = performanceData?.evPerformance?.[perm];
                  return {
                      name: perm,
                      'EV KM': performance?.moonLightingDetails?.totalEvKm ?? 0,
                      'Order KM':
                          performance?.moonLightingDetails?.totalOrderKm ?? 0,
                      'Moonlighting %':
                          performance?.moonLightingDetails
                              ?.moonlightingPercentage ?? 0,
                  };
              })
            : [];
    const getTelematicTab = () => {
        const info = evDetails?.evTelematicInfo;

        const textVal = (val: any, suffix = '') =>
            val != null ? (
                <Typography style={{ fontSize: 16, fontWeight: 700, color: '#14112D' }}>
                    {val}{suffix}
                </Typography>
            ) : (
                <Typography style={{ fontSize: 16, color: '#BDBDBD' }}>—</Typography>
            );

        const boolChip = (val: any, trueLabel = 'On', falseLabel = 'Off') => {
            if (val == null) return <Typography style={{ fontSize: 16, color: '#BDBDBD' }}>—</Typography>;
            const active = !!val;
            return (
                <Box display="inline-flex" alignItems="center" px={1.5} py={0.4} borderRadius={20}
                    style={{ backgroundColor: active ? '#E8F5E9' : '#FFEBEE' }}>
                    <Box width={7} height={7} borderRadius="50%" mr={0.75}
                        style={{ backgroundColor: active ? '#4CAF50' : '#F44336' }} />
                    <span style={{ fontSize: 13, fontWeight: 700, color: active ? '#2E7D32' : '#C62828' }}>
                        {active ? trueLabel : falseLabel}
                    </span>
                </Box>
            );
        };

        const seatChip = (val: any) => {
            if (!val) return <Typography style={{ fontSize: 16, color: '#BDBDBD' }}>—</Typography>;
            return (
                <Box display="inline-flex" alignItems="center" px={1.5} py={0.4} borderRadius={20}
                    style={{ backgroundColor: '#E3F2FD' }}>
                    <span style={{ fontSize: 13, fontWeight: 700, color: '#1565C0' }}>{val}</span>
                </Box>
            );
        };

        type CtrlBtn = { label: string; action: string; checked: boolean; isEnergy: boolean };

        const MetricTile = ({ label, children, btn }: { label: string; children: any; btn?: CtrlBtn }) => (
            <Box p={2} borderRadius={10} height="100%" display="flex" flexDirection="column" justifyContent="space-between"
                style={{ backgroundColor: '#F8F9FF', border: '1px solid #EBEDF8' }}>
                <Box>
                    <Typography style={{ fontSize: 11, fontWeight: 700, color: '#7B8094',
                        textTransform: 'uppercase', letterSpacing: 0.8, marginBottom: 8 }}>
                        {label}
                    </Typography>
                    {children}
                </Box>
                {btn && (
                    <Box mt={1.5} display="flex" alignItems="center" justifyContent="space-between">
                        <Typography style={{ fontSize: 12, color: btn.checked ? '#2E7D32' : '#9E9E9E', fontWeight: 600 }}>
                            {btn.checked ? 'ON' : 'OFF'}
                        </Typography>
                        <Tooltip title={btn.label}>
                            <span>
                                <IOSSwitch
                                    checked={btn.checked}
                                    onChange={() => setTelematicConfirm({ action: btn.action, label: btn.label, isEnergy: btn.isEnergy })}
                                    onClick={(e: any) => { e?.stopPropagation(); e?.preventDefault(); }}
                                    name={`tile-switch-${label}`}
                                />
                            </span>
                        </Tooltip>
                    </Box>
                )}
            </Box>
        );

        const SectionBanner = ({ title, name, color }: any) => (
            <Box display="flex" alignItems="center" justifyContent="space-between" mb={2.5} px={2} py={1.5}
                borderRadius={10} style={{ backgroundColor: color + '0D', borderLeft: `4px solid ${color}` }}>
                <Box>
                    <Typography style={{ fontSize: 11, fontWeight: 700, color, textTransform: 'uppercase', letterSpacing: 0.8, marginBottom: 2 }}>
                        {title}
                    </Typography>
                    <Typography style={{ fontSize: 17, fontWeight: 700, color: '#14112D' }}>
                        {name ?? <span style={{ color: '#9E9E9E', fontWeight: 500 }}>Not configured</span>}
                    </Typography>
                </Box>
                <Box display="inline-flex" alignItems="center" px={1.5} py={0.5} borderRadius={20}
                    style={{ backgroundColor: name ? '#E8F5E9' : '#F5F5F5', flexShrink: 0 }}>
                    <Box width={7} height={7} borderRadius="50%" mr={0.75}
                        style={{ backgroundColor: name ? '#4CAF50' : '#BDBDBD' }} />
                    <Typography style={{ fontSize: 12, fontWeight: 600, color: name ? '#2E7D32' : '#9E9E9E' }}>
                        {name ? 'Mapped' : 'Not mapped'}
                    </Typography>
                </Box>
            </Box>
        );

        // ── Per-partner control resolution ──────────────────────────────────
        const iotPartnerLower = (evDetails?.iotPartnerName ?? '').toLowerCase();
        const epPartnerLower  = (evDetails?.energyPartnerName ?? '').toLowerCase();
        const iotCtrlEnabled  = !!evDetails?.iotPartnerRemoteControlEnabled;
        const epCtrlEnabled   = !!evDetails?.energyPartnerRemoteControlEnabled && !!evDetails?.energyPartnerName;

        const mkBtn = (label: string, action: string, checked: boolean, isEnergy: boolean): CtrlBtn =>
            ({ label, action, checked, isEnergy });

        // IoT tile buttons — use the same fields the display chips use
        const ignOn     = !!info?.vehicleIgnitionStatus;   // chip: On/Off
        const mobilized = !!info?.mobilityStatus;          // chip: Active/Inactive
        const seatOpen  = info?.seatStatus === 'SEAT_OPEN'; // chip: seat string

        const iotIgnBtn: CtrlBtn | undefined =
            iotCtrlEnabled && iotPartnerLower === 'connectm'
                ? mkBtn(ignOn ? 'Turn OFF' : 'Turn ON', ignOn ? 'IGN_OFF' : 'IGN_ON', ignOn, false)
                : undefined;

        const iotMobBtn: CtrlBtn | undefined =
            iotCtrlEnabled && (iotPartnerLower === 'intellicar' || iotPartnerLower === 'greentiger')
                ? mkBtn(mobilized ? 'Immobilize' : 'Mobilize', mobilized ? 'immobilize' : 'mobilize', mobilized, false)
                : undefined;

        const iotSeatBtn: CtrlBtn | undefined =
            iotCtrlEnabled && iotPartnerLower === 'connectm'
                ? mkBtn(seatOpen ? 'Close Seat' : 'Open Seat', seatOpen ? 'SEAT_CLOSE' : 'SEAT_OPEN', seatOpen, false)
                : undefined;

        // Energy partner tile buttons
        const epIgnOn     = info?.energyPartnerIgnitionStatus != null ? !!info.energyPartnerIgnitionStatus : false;
        const epMobilized = !!info?.mobilityStatus; // same mobility field — energy partner shares the vehicle state

        const epIgnBtn: CtrlBtn | undefined =
            epCtrlEnabled && epPartnerLower === 'connectm'
                ? mkBtn(epIgnOn ? 'Turn OFF' : 'Turn ON', epIgnOn ? 'IGN_OFF' : 'IGN_ON', epIgnOn, true)
                : undefined;

        const epMobBtn: CtrlBtn | undefined =
            epCtrlEnabled && epPartnerLower === 'indofast'
                ? mkBtn(epMobilized ? 'Immobilize' : 'Mobilize', epMobilized ? 'immobilize' : 'mobilize', epMobilized, true)
                : undefined;

        const iotTiles = [
            { label: 'Ignition',    node: boolChip(info?.vehicleIgnitionStatus),                                   btn: iotIgnBtn },
            { label: 'Mobility',    node: boolChip(info?.mobilityStatus, 'Active', 'Inactive'),                    btn: iotMobBtn },
            { label: 'Battery',     node: textVal(info?.vehicleBattery, '%') },
            { label: 'Speed',       node: textVal(info?.speed, ' km/h') },
            { label: 'Odometer',    node: textVal(info?.odometer, ' km') },
            { label: 'Seat Status', node: seatChip(info?.seatStatus),                                              btn: iotSeatBtn },
            { label: 'Latitude',    node: textVal(info?.latitude) },
            { label: 'Longitude',   node: textVal(info?.longitude) },
        ];

        const epTiles = [
            { label: 'Ignition',  node: boolChip(info?.energyPartnerIgnitionStatus != null ? !!info.energyPartnerIgnitionStatus : null), btn: epIgnBtn },
            { label: 'Mobility',  node: boolChip(info?.mobilityStatus, 'Active', 'Inactive'),                                            btn: epMobBtn },
            { label: 'Battery',   node: textVal(info?.energyPartnerBattery, '%') },
            { label: 'Speed',     node: textVal(info?.energyPartnerSpeed, ' km/h') },
            { label: 'Odometer',  node: textVal(info?.energyPartnerOdometer, ' km') },
            { label: 'Latitude',  node: textVal(info?.energyPartnerLatitude) },
            { label: 'Longitude', node: textVal(info?.energyPartnerLongitude) },
        ];

        return {
            label: 'Telematic Data',
            icon: <StorageIcon style={{ width: 20, height: 20 }} />,
            content: (
                <Box className={classes.tableContainer} pt={1}>
                    {/* IoT Partner */}
                    <Box mb={4}>
                        <SectionBanner title="IoT Partner" name={evDetails?.iotPartnerName} color="#4B6EFB" />
                        <Grid container spacing={2}>
                            {iotTiles.map((t) => (
                                <Grid item xs={6} sm={4} md={3} key={t.label}>
                                    <MetricTile label={t.label} btn={t.btn}>{t.node}</MetricTile>
                                </Grid>
                            ))}
                        </Grid>
                    </Box>

                    <Divider style={{ margin: '4px 0 24px', backgroundColor: '#EAEDF3' }} />

                    {/* Energy Partner */}
                    <Box>
                        <SectionBanner title="Energy Partner" name={evDetails?.energyPartnerName} color="#FF6D00" />
                        {evDetails?.energyPartnerName ? (
                            <Grid container spacing={2}>
                                {epTiles.map((t) => (
                                    <Grid item xs={6} sm={4} md={3} key={t.label}>
                                        <MetricTile label={t.label} btn={t.btn}>{t.node}</MetricTile>
                                    </Grid>
                                ))}
                            </Grid>
                        ) : (
                            <Box p={4} borderRadius={10} textAlign="center"
                                style={{ backgroundColor: '#F8F9FF', border: '1px dashed #BFCFFF' }}>
                                <Typography style={{ color: '#9E9E9E', fontSize: 14, fontWeight: 500 }}>
                                    No energy partner mapped to this vehicle
                                </Typography>
                            </Box>
                        )}
                    </Box>
                </Box>
            ),
            disabled: false,
        };
    };

    const getOverviewTab = () => {
        const dash = <span style={{ color: '#BDBDBD' }}>—</span>;
        const fmtVal = (v: any) =>
            v == null || v === '' ? dash : String(v);

        const ov = overviewData ?? {};
        const ovRider = ov?.rider ?? ov?.riderDetails ?? {};
        const ovEv = ov?.ev ?? ov?.evDetails ?? ov ?? {};
        const ovAssignment = ov?.assignment ?? ov?.tagging ?? {};
        const rider = currentRider ?? {};
        const tl = ov?.teamLeader
            ?? ovAssignment?.teamLeader
            ?? evDetails?.tlDetails
            ?? evDetails?.captainDetails
            ?? {};
        const tlName = tl?.name ?? evDetails?.captainName;
        const tlMobile = tl?.contactNumber ?? evDetails?.captainContactNumber;
        const teamLeaderStr = tlName
            ? tlMobile ? `${tlName} · ${tlMobile}` : tlName
            : null;

        const riderRows: { label: string; value: any }[] = [
            { label: 'Name', value: ovRider?.name ?? rider?.riderName ?? evDetails?.taggedRiderDetails?.name },
            { label: 'Mobile', value: ovRider?.contactNumber ?? ovRider?.mobile ?? rider?.riderContactNumber ?? evDetails?.taggedRiderDetails?.contactNumber },
            { label: 'StaffPay ID', value: ovRider?.staffPayId ?? rider?.staffPayId ?? evDetails?.staffPayId },
            { label: 'Customer ID', value: ovRider?.customerCode ?? rider?.customerCode ?? evDetails?.riderCustomerCode },
            { label: 'Hermes ID', value: ovRider?.hermesId ?? rider?.hermesId ?? evDetails?.hermesId },
        ];

        const cmName = ov?.clusterManagerName ?? ov?.cmName ?? evDetails?.clusterManagerName ?? evDetails?.cmName;
        const assignmentRows: { label: string; value: any }[] = [
            { label: 'Team Leader', value: teamLeaderStr },
            { label: 'Cluster Manager', value: cmName },
        ];

        const evRows: { label: string; value: any }[] = [
            { label: 'EV Number', value: ovEv?.evNumber ?? evDetails?.evNumber },
            { label: 'Vehicle Number', value: ovEv?.evVehicleNumber ?? evDetails?.evVehicleNumber },
            { label: 'Chassis', value: ovEv?.chassisNumber ?? evDetails?.chassisNumber },
            { label: 'Energy Partner', value: ovEv?.energyPartnerName ?? evDetails?.energyPartnerName },
            { label: 'IoT Partner', value: ovEv?.iotPartnerName ?? evDetails?.iotPartnerName },
            { label: 'Battery Level', value: ovEv?.batteryLevel ?? ovEv?.batteryCapacity ?? evDetails?.batteryCapacity },
        ];

        const projectRaw =
            ov?.projects
            ?? ov?.projectMappings
            ?? ov?.taggedVerticals
            ?? ovAssignment?.projects
            ?? ov?.project
            ?? ovEv?.project
            ?? ovAssignment?.project
            ?? evDetails?.project
            ?? null;
        const projectList: any[] = Array.isArray(projectRaw)
            ? projectRaw
            : projectRaw
                ? [typeof projectRaw === 'string'
                    ? { project: projectRaw, projectId: ov?.projectId ?? ovEv?.projectId ?? ovAssignment?.projectId ?? evDetails?.projectId }
                    : projectRaw]
                : [];
        const verticalRows = projectList.map((p: any) => ({
            vertical: p?.project ?? p?.vertical ?? '',
            clientId: p?.projectId ?? p?.clientId ?? p?.id ?? null,
        })).filter((r) => r.vertical);

        // Status
        const isActive = !!(ovEv?.isActive ?? evDetails?.isActive ?? evDetails?.is_active);
        const bucket = evDetails?.bucket;
        const bucketPalette: Record<string, { bg: string; fg: string }> = {
            CRITICAL: { bg: '#FFE5E5', fg: '#C62828' },
            WARNING:  { bg: '#FFF4E5', fg: '#B26A00' },
            HEALTHY:  { bg: '#E8F7EC', fg: '#1E8A3C' },
            GOOD:     { bg: '#E8F7EC', fg: '#1E8A3C' },
        };
        const bucketColor = bucketPalette[(bucket ?? '').toUpperCase()] ?? { bg: '#F1F2F8', fg: '#3B3F52' };

        const lastBlockEvent = (commandHistory ?? [])[0];
        const extractResponseMessage = (raw: any): string | null => {
            if (raw == null) return null;
            let val: any = raw;
            // Unwrap up to 2 levels of JSON-encoded string
            for (let i = 0; i < 2 && typeof val === 'string'; i++) {
                const trimmed = val.trim();
                if (!trimmed.startsWith('{') && !trimmed.startsWith('[')) break;
                try { val = JSON.parse(trimmed); } catch { break; }
            }
            if (typeof val === 'string') return val.trim() || null;
            if (val && typeof val === 'object') {
                const candidate =
                    val?.data?.response_text ??
                    val?.data?.responseText ??
                    val?.data?.message ??
                    val?.response_text ??
                    val?.responseText ??
                    val?.message;
                if (typeof candidate === 'string' && candidate.trim()) return candidate.trim();
            }
            return null;
        };
        const lastBlockMessage = extractResponseMessage(lastBlockEvent?.responseText);
        const lastBlockStr = lastBlockEvent
            ? `${moment(lastBlockEvent?.happenedAt ?? lastBlockEvent?.createdAt).format('MMM D, HH:mm')} — ${
                (lastBlockEvent?.commandType ?? '').replace(/_/g, ' ')
              }${lastBlockEvent?.sentByName ? ` by ${lastBlockEvent.sentByName}` : ''}${
                lastBlockEvent?.role ? ` (${lastBlockEvent.role})` : ''
              }${lastBlockMessage ? ` — ${lastBlockMessage}` : ''}`
            : null;

        const sectionTitleStyle: React.CSSProperties = {
            fontSize: 13, fontWeight: 700, color: '#14112D',
            textTransform: 'uppercase', letterSpacing: 0.6,
            margin: '24px 0 12px',
        };

        const cellLabelStyle: React.CSSProperties = {
            fontSize: 11, fontWeight: 700, color: '#7B8094',
            textTransform: 'uppercase', letterSpacing: 0.8,
        };
        const cellValueStyle: React.CSSProperties = {
            fontSize: 14, fontWeight: 700, color: '#14112D',
        };

        const KeyValueTable = ({ rows }: { rows: { label: string; value: any }[] }) => (
            <Box borderRadius={10} style={{ border: '1px solid #EBEDF8', overflow: 'hidden' }}>
                {rows.map((r, idx) => (
                    <Box key={r.label} display="flex" alignItems="center"
                        style={{
                            padding: '14px 20px',
                            borderTop: idx === 0 ? 'none' : '1px solid #EBEDF8',
                        }}>
                        <Box flex={1} style={cellLabelStyle}>{r.label}</Box>
                        <Box flex={2} style={cellValueStyle}>{fmtVal(r.value)}</Box>
                    </Box>
                ))}
            </Box>
        );

        return {
            label: 'Overview',
            icon: <InfoOutlinedIcon style={{ width: 20, height: 20 }} />,
            content: (
                <Box className={classes.tableContainer} pt={1}>
                    {/* RIDER */}
                    <Typography style={sectionTitleStyle}>Rider</Typography>
                    <KeyValueTable rows={riderRows} />

                    {/* EV */}
                    <Typography style={sectionTitleStyle}>EV</Typography>
                    <KeyValueTable rows={evRows} />

                    {/* ASSIGNMENT */}
                    <Typography style={sectionTitleStyle}>Assignment</Typography>
                    <KeyValueTable rows={assignmentRows} />
                    <Typography style={{ fontSize: 11, fontWeight: 700, color: '#7B8094',
                        textTransform: 'uppercase', letterSpacing: 0.8, margin: '16px 0 8px' }}>
                        Project IDs (Tagged Verticals)
                    </Typography>
                    <Box borderRadius={10} style={{ border: '1px solid #EBEDF8', overflow: 'hidden' }}>
                        <Box display="flex" alignItems="center"
                            style={{ padding: '12px 20px', backgroundColor: '#F8F9FF' }}>
                            <Box flex={1} style={cellLabelStyle}>Vertical</Box>
                        </Box>
                        {verticalRows.length === 0 ? (
                            <Box display="flex" alignItems="center"
                                style={{ padding: '14px 20px', borderTop: '1px solid #EBEDF8' }}>
                                <Box flex={1} style={{ fontSize: 14, color: '#BDBDBD' }}>EV not tagged to any vertical</Box>
                            </Box>
                        ) : verticalRows.map((r) => (
                            <Box key={r.vertical} display="flex" alignItems="center"
                                style={{ padding: '14px 20px', borderTop: '1px solid #EBEDF8' }}>
                                <Box flex={1} style={{ fontSize: 14, color: '#14112D' }}>{r.vertical}</Box>
                            </Box>
                        ))}
                    </Box>

                    {/* STATUS */}
                    <Typography style={sectionTitleStyle}>Status</Typography>
                    <Box borderRadius={10} style={{ border: '1px solid #EBEDF8', overflow: 'hidden' }}>
                        <Box display="flex" alignItems="center"
                            style={{ padding: '14px 20px' }}>
                            <Box flex={1} style={cellLabelStyle}>Vehicle State</Box>
                            <Box flex={2}>
                                <Box display="inline-flex" alignItems="center" px={1.25} py={0.4} borderRadius={20}
                                    style={{ backgroundColor: isActive ? '#E8F7EC' : '#F1F2F8' }}>
                                    <span style={{ fontSize: 11, fontWeight: 700,
                                        color: isActive ? '#1E8A3C' : '#3B3F52', letterSpacing: 0.4 }}>
                                        {isActive ? 'ACTIVE' : 'INACTIVE'}
                                    </span>
                                </Box>
                            </Box>
                        </Box>
                        <Box display="flex" alignItems="center"
                            style={{ padding: '14px 20px', borderTop: '1px solid #EBEDF8' }}>
                            <Box flex={1} style={cellLabelStyle}>Bucket</Box>
                            <Box flex={2}>
                                {bucket ? (
                                    <Box display="inline-flex" alignItems="center" px={1.25} py={0.4} borderRadius={20}
                                        style={{ backgroundColor: bucketColor.bg }}>
                                        <span style={{ fontSize: 11, fontWeight: 700,
                                            color: bucketColor.fg, letterSpacing: 0.4 }}>
                                            {String(bucket).toUpperCase()}
                                        </span>
                                    </Box>
                                ) : dash}
                            </Box>
                        </Box>
                        <Box display="flex" alignItems="center"
                            style={{ padding: '14px 20px', borderTop: '1px solid #EBEDF8' }}>
                            <Box flex={1} style={cellLabelStyle}>Last Block Event</Box>
                            <Box flex={2} style={cellValueStyle}>
                                {lastBlockStr ?? dash}
                            </Box>
                        </Box>
                    </Box>
                </Box>
            ),
            disabled: false,
        };
    };

    const getBlockHistoryTab = () => {
        const eventChip = (type: string) => {
            const t = (type ?? '').toUpperCase();
            const palette: Record<string, { bg: string; fg: string }> = {
                BLOCK:           { bg: '#FFEBEE', fg: '#C62828' },
                BLOCKED:         { bg: '#FFEBEE', fg: '#C62828' },
                UNBLOCK:         { bg: '#E8F7EC', fg: '#1E8A3C' },
                UNBLOCKED:       { bg: '#E8F7EC', fg: '#1E8A3C' },
                'AUTO-UNBLOCK':  { bg: '#E6EEFF', fg: '#2858E0' },
                AUTO_UNBLOCK:    { bg: '#E6EEFF', fg: '#2858E0' },
                MOBILIZE:        { bg: '#E8F7EC', fg: '#1E8A3C' },
                IMMOBILIZE:      { bg: '#FFEBEE', fg: '#C62828' },
            };
            const c = palette[t] ?? { bg: '#F1F2F8', fg: '#3B3F52' };
            return (
                <Box display="inline-flex" alignItems="center" px={1.25} py={0.4} borderRadius={20}
                    style={{ backgroundColor: c.bg }}>
                    <span style={{ fontSize: 11, fontWeight: 700, color: c.fg, letterSpacing: 0.4 }}>{t || '—'}</span>
                </Box>
            );
        };
        const roleChip = (role: string) => {
            if (!role) return null;
            const r = role.toUpperCase();
            const palette: Record<string, { bg: string; fg: string }> = {
                ADMIN:        { bg: '#EDE9FE', fg: '#5B3FD9' },
                'CENTRAL OPS':{ bg: '#EDE9FE', fg: '#5B3FD9' },
                CM:           { bg: '#EDE9FE', fg: '#5B3FD9' },
                RIDER:        { bg: '#FEF3C7', fg: '#92400E' },
                SYS:          { bg: '#DBEAFE', fg: '#1E40AF' },
                SYSTEM:       { bg: '#DBEAFE', fg: '#1E40AF' },
            };
            const c = palette[r] ?? { bg: '#F1F2F8', fg: '#3B3F52' };
            return (
                <Box ml={1} display="inline-flex" alignItems="center" px={1} py={0.2} borderRadius={6}
                    style={{ backgroundColor: c.bg }}>
                    <span style={{ fontSize: 10, fontWeight: 700, color: c.fg, letterSpacing: 0.6 }}>{r}</span>
                </Box>
            );
        };
        const last10 = (commandHistory ?? []).slice(0, 10);
        return {
            label: 'Block History',
            icon: <HistoryIcon style={{ width: 20, height: 20 }} />,
            content: (
                <Box className={classes.tableContainer} pt={1}>
                    <Typography style={{ fontSize: 16, fontWeight: 700, color: '#14112D', marginBottom: 16 }}>
                        Block History &mdash; Last 10 events
                    </Typography>
                    {commandHistoryLoading ? (
                        <Box p={4} textAlign="center">
                            <Typography style={{ color: '#9E9E9E', fontSize: 14 }}>Loading…</Typography>
                        </Box>
                    ) : !last10.length ? (
                        <Box p={4} borderRadius={10} textAlign="center"
                            style={{ backgroundColor: '#F8F9FF', border: '1px dashed #BFCFFF' }}>
                            <Typography style={{ color: '#9E9E9E', fontSize: 14, fontWeight: 500 }}>
                                No block events for this vehicle
                            </Typography>
                        </Box>
                    ) : (
                        <Box style={{ overflowX: 'auto' }}>
                            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
                                <thead>
                                    <tr style={{ backgroundColor: '#F8F9FF', textAlign: 'left' }}>
                                        {['Event', 'Actor', 'Reason', 'Wallet @ Event', 'Decay @ Event', 'Bucket @ Event', 'Timestamp'].map((h) => (
                                            <th key={h} style={{ padding: '14px 12px', fontSize: 11, fontWeight: 700,
                                                color: '#7B8094', textTransform: 'uppercase', letterSpacing: 0.6,
                                                borderBottom: '1px solid #EBEDF8' }}>{h}</th>
                                        ))}
                                    </tr>
                                </thead>
                                <tbody>
                                    {last10.map((c: any) => {
                                        const actorName = c?.sentByName || (c?.sentBy != null ? `User ${c.sentBy}` : 'System');
                                        const wallet = c?.walletBalance;
                                        const walletStr = wallet == null ? '—' :
                                            (wallet < 0 ? `₹-${Math.abs(wallet)}` : `₹${wallet}`);
                                        return (
                                            <tr key={c?.id} style={{ borderBottom: '1px solid #F1F2F8' }}>
                                                <td style={{ padding: '14px 12px' }}>{eventChip(c?.commandType)}</td>
                                                <td style={{ padding: '14px 12px', color: '#14112D', fontWeight: 600 }}>
                                                    {actorName}{roleChip(c?.role)}
                                                </td>
                                                <td style={{ padding: '14px 12px', color: '#5A6075', maxWidth: 280,
                                                    whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}
                                                    title={c?.remarks ?? ''}>
                                                    {c?.remarks ?? '—'}
                                                </td>
                                                <td style={{ padding: '14px 12px',
                                                    color: wallet != null && wallet < 0 ? '#C62828' : '#14112D',
                                                    fontWeight: 600 }}>
                                                    {walletStr}
                                                </td>
                                                <td style={{ padding: '14px 12px', color: '#14112D' }}>
                                                    {c?.decayDays != null ? `${c.decayDays}d` : '—'}
                                                </td>
                                                <td style={{ padding: '14px 12px', color: '#14112D', fontWeight: 600 }}>
                                                    {c?.bucket ?? '—'}
                                                </td>
                                                <td style={{ padding: '14px 12px', color: '#5A6075', whiteSpace: 'nowrap' }}>
                                                    {c?.happenedAt ? moment(c.happenedAt).format('MMM D, HH:mm') :
                                                     c?.createdAt ? moment(c.createdAt).format('MMM D, HH:mm') : '—'}
                                                </td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        </Box>
                    )}
                </Box>
            ),
            disabled: false,
        };
    };

    const getTabs = (rider: any) => {
        return [
            getOverviewTab(),
            {
                label: 'Tagging History',
                icon: <EVVehicleRider />,
                content: (
                    <EVTaggingHistory
                        historyData={historyData}
                        fetchEVHistoryListData={fetchEVHistoryListData}
                    />
                ),
                disabled: false,
            },
            {
                label: 'Map view',
                icon: <EVVehicleMap />,
                content: (
                    <Box className={classes.mapContainer}>
                        {!!performanceData &&
                            performanceData?.evPerformance &&
                            !!Object.keys(performanceData?.evPerformance)
                                ?.length && (
                                <Box
                                    display={'flex'}
                                    alignItems={'center'}
                                    justifyContent={'flex-end'}
                                    mb={1}
                                >
                                    <Box
                                        display={'flex'}
                                        alignItems={'center'}
                                        justifyContent={'space-between'}
                                        minWidth={'336px'}
                                        className={classes.performBox}
                                        p={2}
                                        onClick={handlePerformClick}
                                    >
                                        <Typography
                                            className={classes.performHeader}
                                        >
                                            EV Performance
                                        </Typography>
                                        <ArrowDropDownCircleIcon
                                            color={'primary'}
                                        />
                                    </Box>
                                    {anchorEl && (
                                        <Popover
                                            id={evGoalId}
                                            open={open}
                                            anchorEl={anchorEl}
                                            onClose={handlePerformClose}
                                            anchorOrigin={{
                                                vertical: 'bottom',
                                                horizontal: 'right',
                                            }}
                                            transformOrigin={{
                                                vertical: 'bottom',
                                                horizontal: 'right',
                                            }}
                                            PaperProps={{
                                                square: true,
                                                classes: {
                                                    root: classes.performBoxExtended,
                                                },
                                            }}
                                            onClick={handlePerformClose}
                                        >
                                            <Box
                                                display={'flex'}
                                                alignItems={'center'}
                                                justifyContent={'space-between'}
                                                minWidth={'100%'}
                                            >
                                                <Typography
                                                    className={
                                                        classes.performHeader
                                                    }
                                                >
                                                    EV Performance
                                                </Typography>
                                                <ArrowDropDownCircleIcon
                                                    color={'primary'}
                                                />
                                            </Box>
                                            <Divider
                                                style={{
                                                    margin: '16px 0',
                                                    backgroundColor: '#EAEDF3',
                                                }}
                                            />
                                            <Box
                                                onClick={(e) => {
                                                    e?.stopPropagation();
                                                    e?.preventDefault();
                                                }}
                                            >
                                                <BarChart
                                                    width={500}
                                                    height={390}
                                                    data={data}
                                                >
                                                    {/* <CartesianGrid strokeDasharray="3 3" /> */}
                                                    <XAxis
                                                        dataKey="name"
                                                        tickMargin={16}
                                                    />
                                                    {/* <YAxis /> */}
                                                    <RechartsTooltip />
                                                    <Legend
                                                        verticalAlign="top"
                                                        iconSize={16}
                                                        letterSpacing={0.144}
                                                        margin={{}}
                                                        wrapperStyle={{
                                                            marginBottom: 24,
                                                        }}
                                                    />
                                                    <Bar
                                                        dataKey="EV KM"
                                                        fill="rgba(188, 187, 244, 1)"
                                                        barSize={24}
                                                        legendType="square"
                                                    />
                                                    <Bar
                                                        dataKey="Order KM"
                                                        fill="#9DEFA0"
                                                        barSize={24}
                                                        legendType="square"
                                                    />
                                                    <Bar
                                                        dataKey="Moonlighting %"
                                                        fill="#FAAC74"
                                                        barSize={24}
                                                        legendType="square"
                                                    />
                                                </BarChart>
                                            </Box>
                                        </Popover>
                                    )}
                                </Box>
                            )}
                        <RiderMapView
                            heliosTrackingData={[]}
                            staffTrackAndTrace={{
                                id: rider?.riderUserId,
                            }}
                            singleEVDetails={{
                                ...evDetails,
                                onPressMobilize: onPressMobilize,
                            }}
                        />
                    </Box>
                ),
                disabled: !rider?.riderUserId,
            },
            getTelematicTab(),
            getBlockHistoryTab(),
        ];
    };
    const tabs: Array<any> = getTabs(currentRider);
    console.log(currentActiveRider);
    return (
        <Spinner loading={loading}>
            <Paper
                style={{ padding: '14px 20px' }}
                className={classes.infoContainer}
                elevation={0}
            >
                <Grid
                    container
                    spacing={1}
                    direction="row"
                    alignItems={'center'}
                >
                    <Grid item xs={6}>
                        <Box
                            display={'flex'}
                            flexDirection={'row'}
                            alignItems={'center'}
                            justifyContent={'flex-start'}
                        >
                            <ListItemIcon
                                onClick={(e) =>
                                    props?.history.push('/ev-sp', {
                                        payload:
                                            props?.location?.state?.payload,
                                        selectedFilter:
                                            props?.location?.state
                                                ?.selectedFilter,
                                    })
                                }
                                className={classes.backIcon}
                            >
                                <ArrowBackIcon
                                    style={{
                                        fontSize: '1.5rem',
                                    }}
                                />
                            </ListItemIcon>
                            <Box>
                                <Typography className={classes.evNumber}>
                                    {evDetails?.evNumber}
                                </Typography>
                            </Box>
                        </Box>
                    </Grid>
                    <Grid item xs={6}>
                        <Box
                            display={'flex'}
                            flexDirection={'row'}
                            alignItems={'center'}
                            justifyContent={'flex-end'}
                        >
                            {CARD_ACTION_CTA?.filter(
                                (item) => !!item?.show,
                            )?.map((cta: any, index: number) => {
                                return (
                                    <React.Fragment key={`top-action-${index}`}>
                                        <Box ml={3}>{cta?.component}</Box>
                                    </React.Fragment>
                                );
                            })}
                        </Box>
                    </Grid>
                </Grid>
            </Paper>
            <Paper className={classes.container} elevation={0}>
                <Tabbar
                    tabs={tabs}
                    tabIndex={tabIndex}
                    lastIndex={null}
                    style={{
                        justifyContent: 'flex-start',
                    }}
                    textStyle={null}
                    boxStyle={{
                        width: 'auto',
                        padding: '1rem',
                        minWidth: '136px',
                    }}
                    onChange={(index: number, isModal: any) => {
                        if (isModal) {
                            setModalTabIndex(index);
                        } else {
                            setTabIndex(index);
                            setModalTabIndex(-1);
                        }
                    }}
                />
                <Divider style={{ margin: '1rem 0' }} />
                <Box>
                    <TabTitle title={tabs?.[tabIndex]?.label} />
                    {!tabs?.[tabIndex]?.disabled &&
                    tabs?.[modalTabIndex]?.isModal
                        ? tabs?.[modalTabIndex].content
                        : null}
                    {!tabs?.[tabIndex]?.disabled
                        ? tabs?.[tabIndex]?.content
                        : null}
                </Box>
            </Paper>
            {!!confirmModalOpen && !!evDetails && (
                <ConfirmModal
                    open={confirmModalOpen}
                    data={evDetails}
                    onClose={() => {
                        setConfirmModalOpen(false);
                    }}
                    confirmationText={`remotely switch ${
                        !!evDetails?.evTelematicInfo?.mobiliStatus
                            ? 'ON'
                            : 'OFF'
                    } the EV`}
                    onAction={() => {
                        setConfirmModalOpen(false);
                        onPressMobilize(evDetails);
                    }}
                />
            )}
            {!!telematicConfirm && (
                <ConfirmModal
                    open={!!telematicConfirm}
                    data={evDetails}
                    onClose={() => { setTelematicConfirm(null); setRemarksInput(''); }}
                    confirmationText={`send command "${telematicConfirm.label}" to this vehicle`}
                    onAction={executeTelematicAction}
                >
                    <Box mt={2}>
                        <TextField
                            label="Remarks (optional)"
                            placeholder="Reason for this action"
                            value={remarksInput}
                            onChange={(e) => setRemarksInput(e.target.value)}
                            fullWidth
                            multiline
                            rows={2}
                            variant="outlined"
                            inputProps={{ maxLength: 500 }}
                        />
                    </Box>
                </ConfirmModal>
            )}
        </Spinner>
    );
};

export default SingleEV;
